<template>
  <div id="monerisCheckout">
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
    <v-alert v-model="showAlert" :type="alertType">{{ alertMessage }}</v-alert>
  </div>
</template>

<script>
import { Api } from "@/plugins/api"
import monerisResponseCode from "@/plugins/monerisResponseCode"
import { loadScript } from "vue-plugin-load-script"

// Page d'affichage de la modale Moneris Checkout
export default {
  name: "MonerisCheckout",
  props: {
    idFacture: String
  },
  data() {
    return {
      // Instance Moneris
      moneris: null,
      // Token de paiement généré par Moneris
      token: null,
      loading: false,
      showAlert: false,
      alertMessage: null,
      alertType: "success"
    }
  },
  mounted() {
    this.loading = true
    // Validation des paramètres obligatoires
    if (this.validerParametres()) {
      // Chargement du script de la librairie Moneris checkout
      loadScript(process.env.VUE_APP_MONERIS_CHECKOUT)
        .then(() => {
          // eslint-disable-next-line
          this.moneris = new monerisCheckout()
          this.moneris.setMode(process.env.VUE_APP_MONERIS_ENVIRONMENT)
          this.moneris.setCheckoutDiv("monerisCheckout")
          // Configuration des callbacks
          this.moneris.setCallback("page_loaded", this.handleEvent)
          this.moneris.setCallback("cancel_transaction", this.handleEvent)
          this.moneris.setCallback("error_event", this.handleEvent)
          this.moneris.setCallback("payment_receipt", this.creerTransaction)
          this.moneris.setCallback("payment_complete", this.handleEvent)
          this.moneris.setCallback("payment_submitted", this.handleEvent)
          this.moneris.setCallback("page_closed", this.handleEvent)

          const self = this
          // Service de chargement de la transaction Moneris à faire pour que le formulaire de Moneris s'affiche
          this.preloadRequest({ factureId: this.idFacture, langue: process.env.VUE_APP_DEFAULT_LANG })
            .then((response) => {
              if (response.data != "" && response.data != null && response.data != undefined) {
                if (response.data === "no ticket") {
                  window.location.reload()
                } else {
                  self.moneris.startCheckout(response.data)
                  self.token = response.data
                }
              } else {
                this.displayError("Échec de génération de la page de paiement, merci de fermer et réessayer.")
              }
            })
            .catch((err) => {
              this.displayError(err.message)
            })
        })
        .catch((e) => {
          this.displayError("Erreur : Échec de chargement du script Moneris, merci de fermer et réessayer. " + e.message)
        })
    } else {
      this.displayError("Erreur : Veuillez vérifier les paramètres envoyés à l'application.")
    }
  },
  methods: {
    // Gestionnaire d'interprétation des retours Moneris
    handleEvent(e) {
      if (this.loading === true) {
        this.$emit("paiementEudonetStart")
      }

      let monerisResponse
      try {
        monerisResponse = JSON.parse(e)
        if (!monerisResponse) {
          throw new Error("Réponse Moneris invalide")
        }
      } catch (e) {
        this.displayError("Erreur : Échec d'interprétation du retour de Moneris, merci de fermer et réessayer. " + e.message)
        return false
      }

      if (monerisResponse.handler === "page_loaded") {
        return monerisResponse.response_code === "001"
      }

      if (monerisResponse.handler === "cancel_transaction") {
        this.cancelRequest({ factureId: this.idFacture, token: this.token })
        this.moneris.closeCheckout(monerisResponse.ticket)
        this.$emit("paiementEudonetComplete")
      } else if (monerisResponse.handler === "payment_complete") {
        this.moneris.closeCheckout(monerisResponse.ticket)
      } else {
        this.displayMessage(
          monerisResponse.response_code != "001" ? "error" : "info",
          monerisResponseCode.responses.find((rc) => rc.code == monerisResponse.response_code).reason
        )
      }

      return monerisResponse.response_code === "001"
    },
    // Webservice de création de la transaction dans Eudonet
    creerTransaction(e) {
      this.loading = true
      if (!this.handleEvent(e)) {
        return
      }

      const self = this
      // Service demandant à Moneris les informations du paiement qui vient d'être fait.
      this.receiptRequest({ factureId: this.idFacture, token: this.token })
        .then((response) => {
          if (response.data == true) {
            self.$emit("paiementEudonetComplete")
          }
        })
        .catch((err) => {
          this.displayError(err.message)
        })
        .finally(() => this.loading = false)
    },
    validerParametres() {
      if (this.isNullOrEmpty(this.idFacture)) {
        return false
      } else {
        return true
      }
    },
    isNullOrEmpty(value) {
      return value === undefined || value === "" || value === null
    },
    displayError(message){
      this.displayMessage("error", message)
    },
    displayMessage(type, message){
      this.alertMessage = message
      this.showAlert = true
      this.alertType = type
      this.loading = false
    },
    preloadRequest: (payload) => Api.get("moneris-checkout/" + payload.factureId + "/preload/" + payload.langue),
    receiptRequest: (payload) => Api.post("moneris-checkout/" + payload.factureId + "/receipt", { token: payload.token }),
    cancelRequest: (payload) => Api.post("moneris-checkout/" + payload.factureId + "/cancel", { token: payload.token })
  }
}
</script>

<style scoped></style>
